import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Badge, Box, Checkbox, FieldAlert } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import styles from './eventPicker.module.scss';
export function EventPicker({ events, input, meta, }) {
    var _a;
    const isCheckedAll = events.length > 0 && events.length === input.value.length;
    const showError = meta.error && meta.submitFailed;
    const onSelectAll = () => {
        if (isCheckedAll) {
            input.onChange([]);
        }
        else {
            input.onChange(events.slice());
        }
    };
    const readableEventName = (event) => {
        const newEvent = event.split('_').slice(1).join(' ').toLowerCase();
        return newEvent.charAt(0).toUpperCase() + newEvent.slice(1);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Box, Object.assign({ className: classnames(styles.container, {
                    [styles.containerBorder]: showError,
                }) }, { children: [_jsx("div", Object.assign({ className: styles.header }, { children: _jsxs("label", Object.assign({ className: styles.title }, { children: [_jsx(Checkbox, { id: "event_picker_all", name: "event_picker_all", className: styles.checkbox, checked: isCheckedAll, onChange: onSelectAll }), "Select all events", ((_a = input.value) === null || _a === void 0 ? void 0 : _a.length) > 0 && (_jsx(Badge, Object.assign({ className: styles.titleBadge, size: "small", variant: "secondary" }, { children: input.value.length })))] })) })), _jsx("div", Object.assign({ className: styles.body }, { children: events.map((event) => (_jsx("div", Object.assign({ className: styles.bodyItem }, { children: _jsxs("label", { children: [_jsx(Checkbox, { name: event, className: styles.checkbox, checked: input.value.includes(event), onChange: () => {
                                            input.onChange(input.value.includes(event)
                                                ? input.value.filter((item) => item !== event)
                                                : [...input.value, event]);
                                        } }), readableEventName(event)] }) }), event))) }))] })), showError && (_jsx(FieldAlert, Object.assign({ className: styles.errorMessage, variant: "error" }, { children: meta.error })))] }));
}
